/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './CapitalGainsOption.scss';

import { bool, func, node, number, string } from 'prop-types';
import React from 'react';

import {  AAMBeaconControl, AAMBeaconControlGroup} from "components/shared/Beacon";

const CapitalGainsOption = ({ children, label, onChange, selected, value }) => {
    const inputName = label.split(' ').join('-');

    return (
        <div className="capital-gains-option-wrapper-v2">
            <div className="beacon-on-light">
                <AAMBeaconControlGroup>
                    <AAMBeaconControl inline>
                        <label htmlFor={`radio-group-cap-gains-${label}`}
                            slot="label">
                            {label}
                        </label>
                        <input type="radio"
                            onChange={() => onChange(value)}
                            checked={selected}
                            value={inputName}
                            id={`radio-group-cap-gains-${label}`}
                            name={`radio-group-cap-gains-${label}`} />
                    </AAMBeaconControl>
                </AAMBeaconControlGroup>
            </div>
            {selected && children && (
                <div className="secondary-capital-gains-option">{children}</div>
            )}
        </div>
    );
};

CapitalGainsOption.propTypes = {
    children: node,
    label: string.isRequired,
    onChange: func.isRequired,
    selected: bool.isRequired,
    value: number.isRequired
};

export default CapitalGainsOption;
